<template>
  <div class="bg-circle min-h-screen flex flex-wrap justify-center">
    <contact-faq-header :image="page.active_image" header-text="Kom in contact!" class="mb-32">
      <div class="prose content" v-html="page.template.tekst"/>
    </contact-faq-header>

    <wave-content hide-header text-only one-column>
      <div class="flex flex-wrap -mt-32">
        <div class="w-full mb-6">
          <button
            class="btn mr-4"
            :class="selected === 'ouders' ? 'btn-secondary' : 'btn-secondary-invert'"
            @click="selected = 'ouders'"
          >
            Voor ouders
          </button>
          <button
            class="btn mr-4"
            :class="selected === 'begeleiders' ? 'btn-secondary' : 'btn-secondary-invert'"
            @click="selected = 'begeleiders'"
          >
            Voor begeleiders
          </button>
        </div>

        <section class="w-full lg:w-1/2">
          <main class="relative mb-6 pr-6">
            <div class="contact-content prose" v-html="selectedContent"/>
          </main>
          <footer>
            <div class="h3 text-secondary mb-6 px-1">
              Direct in contact komen?
            </div>
            <div class="flex flex-wrap">
              <div class="flex w-1/2 px-1 flex-1 flex-col">
                <span>Bel voor direct contact naar</span>
                <a :href="`tel:${contactInfo.phone}`" class="font-bold w-content mb-8">{{ contactInfo.phone }}</a>

                <span>Of kom langs op:</span>
                <span class="font-bold">{{ contactInfo.address }}<br>{{ contactInfo.postalcode }} {{ contactInfo.city }}</span>
              </div>
              <div class="flex w-1/2 px-1 flex-1 flex-col">
                <span>Mail direct naar:</span>
                <a :href="`mailto:${contactInfo.email}`" class="font-bold break-words hyphens mb-8">{{ contactInfo.email }}</a>

                <span>BTW-nummer: <strong>{{ contactInfo.btw_nummer }}</strong></span>
                <span>KvK: <strong>{{ contactInfo.kvk }}</strong></span>
              </div>
            </div>
          </footer>
        </section>

        <section class="w-full lg:w-1/2 pt-8 lg:pt-0 lg:pl-6">
          <dynamic-text v-if="!$apollo.loading" :html="page.template.formulier"/>
        </section>
      </div>
    </wave-content>

    <newsletter-subscribe/>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import ContactFaqHeader from '~/components/headers/ContactFaqHeader';
import WaveContent from '~/components/fullwidth-blocks/WaveContent';
import NewsletterSubscribe from '~/components/fullwidth-blocks/NewsletterSubscribe';
import page from '~/plugins/mixins/page';

export default {
  components: {NewsletterSubscribe, WaveContent, ContactFaqHeader},
  mixins: [page],
  data: () => ({
    selected: 'ouders',
  }),
  computed: {
    ...mapState({
      contactInfo: state => state.contactInfo,
    }),
    selectedContent() {
      return this.selected === 'ouders' ? this.page.template.voor_ouders : this.page.template.voor_begeleiders;
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-content {
  ::v-deep h3 {
    @apply mb-4;
  }
}
.hyphens {
  hyphens: auto;
}
</style>
